export const frCa: {[key: string]: string} = {

	Language: 'La langue',
	Login: 'S\'identifier',
	Logout: 'Connectez - Out',

	No: 'Non',

	Yes: 'Oui',
};
